import { render } from "./SettingsScreen.vue?vue&type=template&id=498b0c98"
import script from "./SettingsScreen.vue?vue&type=script&lang=js"
export * from "./SettingsScreen.vue?vue&type=script&lang=js"

import exportComponent from "/home/ruslan/projects/sporttiming/app/front/do/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__